module.exports = __webpack_public_path__ + "img/50497c2.jpg";